export default __webpack_public_path__ + "static/media/Notif - Assignment Reminder.4e9420d3.svg";